/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { CreateVehicleResponse, GetVehicleResponse, UpdateVehicleResponse, UserVehiclesResponse } from '../../app/features/vehicles/domain/vehicle.model';
import { CreateVehicleDto, UpdateVehicleDto } from '../../app/features/vehicles/infrastructure/dto/vehicle.dto';
import { VehiclesRepository } from '../../app/features/vehicles/infrastructure/vehicles.repository';
import { createVehicleResponseMock } from '../dataMocks/create-vehicle-response-mock';
import { getVehicleResponseMock } from '../dataMocks/get-vehicle-response-mock';
import { userVehiclesResponseMock } from '../dataMocks/user-vehicles-mock';

class VehiclesApiServiceMock implements VehiclesRepository {
    createVehicle(createVehicleDto: CreateVehicleDto): Observable<CreateVehicleResponse> {
        return of(createVehicleResponseMock);
    }
    listUserVehicles(page = 1, pageSize = 30, includeDraft = false): Observable<UserVehiclesResponse> {
        return of(userVehiclesResponseMock);
    }
    updateVehicle(id: string, updateVehicleDto: UpdateVehicleDto): Observable<UpdateVehicleResponse> {
        const response = { ...createVehicleResponseMock };
        delete response.availableModels;
        return of(response as unknown as UpdateVehicleResponse);
    }

    //TODO: Esto en back no está
    getVehicle(id: string): Observable<GetVehicleResponse> {
        if (id === 'vehicle-1') {
            const vehicle: GetVehicleResponse = {
                ...getVehicleResponseMock,
                id: 'vehicle-1',
                make: 'Tesla',
                model: 'Model Y',
                year: 2020,
            };
            return of(vehicle);
        }

        if (id === 'vehicle-2') {
            const vehicle: GetVehicleResponse = {
                ...getVehicleResponseMock,
                id: 'vehicle-2',
                make: 'Tesla',
                model: 'Model X',
                year: 2021,
            };
            return of(vehicle);
        }

        if (id === 'vehicle-3') {
            const vehicle: GetVehicleResponse = {
                ...getVehicleResponseMock,
                make: 'Tesla',
                model: 'Model S',
                year: 2022,
                id: 'vehicle-3',
            };
            return of(vehicle);
        }

        if (id === 'vehicle-4') {
            const vehicle: GetVehicleResponse = {
                ...getVehicleResponseMock,
                id: 'vehicle-4',
            };
            return of(vehicle);
        }

        if (id === 'vehicle-5') {
            const vehicle: GetVehicleResponse = {
                ...getVehicleResponseMock,
                id: 'vehicle-5',
            };
            return of(vehicle);
        }
        return of(getVehicleResponseMock);
    }

    reenrollVehicle(id: string): Observable<GetVehicleResponse> {
        return of(getVehicleResponseMock);
    }
}

export { VehiclesApiServiceMock };
